export default __webpack_public_path__ + "bb0f59583d94f3e82152b7a773b50b0c.coffee";